const TAConstants = {
    MAX_TD_ROWS: 3
};
export { TAConstants };